module.exports = __webpack_public_path__ + "static/img/3.74b6e31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-educacion/3.png
// module id = /ojJ
// module chunks = 0